















import { defineComponent, computed } from '@vue/composition-api';
import SharedState from '@/data/SharedState';
export default defineComponent({
  props: {
    hasMore: {
      type: Boolean,
      required: true
    }
  },
  emits: {
   'show-more': () => true
  },
  setup(props, context) {
    const buttonText = computed(() => {
      return SharedState.getText(context, 'corptube.show.more');
    });

    const onShowMore = () => {
      context.emit('show-more');
    };

    return {
      buttonText,
      onShowMore
    };
  }

});
